import { defineStore } from 'pinia'
// @ts-ignore
import { ref, computed } from 'vue'

export const useUiStore = defineStore('ui', () => {
  // State
  const loading = ref(false)
  const error = ref<string | null>(null)
  const success = ref<string | null>(null)
  const modal = ref<any>(null)
  const messages = ref<Record<string, any>>({})

  // Getters
  const isLoading = computed(() => loading.value)
  const getError = computed(() => error.value)
  const getSuccess = computed(() => success.value)
  const getModal = computed(() => modal.value)

  // Actions
  function setLoading(status: boolean) {
    loading.value = status
  }

  function setError(errorMessage: string | null) {
    error.value = errorMessage
  }

  function setSuccess(message: string | null) {
    success.value = message
  }

  function clearMessages() {
    error.value = null
    success.value = null
  }

  function setModal(modalConfig: any) {
    modal.value = modalConfig
  }

  function setMessages(newMessages: Record<string, any>) {
    messages.value = newMessages
  }

  return {
    // State
    loading,
    error,
    success,
    modal,
    messages,
    
    // Getters
    isLoading,
    getError,
    getSuccess,
    getModal,
    
    // Actions
    setLoading,
    setError,
    setSuccess,
    clearMessages,
    setModal,
    setMessages
  }
})